import React, { useState } from "react";
import Modal from "react-modal";

import { ModalStyle } from "Pages/PartnersOrders/styles";
import { useQuery } from "react-query";
import { getSchedulesDetailsAPI } from "Requests/SchedulePartners";
import { Loader } from "Components/Loader";
import { Box } from "styles/globalComponents";
import { formatPhoneNumberIntl } from "react-phone-number-input";
import { Button } from "Components/Button";
import { X } from "lucide-react";
import { ProductModalProps } from "./interface";
import { CancelModal } from "../CancelModal";
import { RescheduleModal } from "../RescheduleModal";

export const ModalViewOrder = ({
  openModal,
  closeModal,
  selectedOrderId,
}: ProductModalProps) => {
  const [modals, setModals] = useState({
    cancelModal: false,
    rescheduleModal: false,
  });

  const { data, isLoading, refetch } = useQuery({
    queryFn: () => getSchedulesDetailsAPI(selectedOrderId),
    queryKey: ["schedule-detail", selectedOrderId],
    enabled: !!selectedOrderId,
    refetchOnWindowFocus: false,
  });

  if (isLoading) {
    return (
      <Modal
        isOpen={openModal}
        bodyOpenClassName="modal-content-open"
        className="modal-content modal-fixed-header modal-product"
        overlayClassName={{
          base: "modal",
          afterOpen: "after-open",
          beforeClose: "before-close",
        }}
        closeTimeoutMS={500}
        onRequestClose={closeModal}
      >
        <ModalStyle>
          <Box mt="40" display="flex" justify="center">
            <Loader />
          </Box>
        </ModalStyle>
      </Modal>
    );
  }

  const openCancelModal = () =>
    setModals({ cancelModal: true, rescheduleModal: false });

  const closeCancelModal = () =>
    setModals({ cancelModal: false, rescheduleModal: false });

  const openRescheduleModal = () =>
    setModals({ cancelModal: false, rescheduleModal: true });

  const closeRescheduleModal = () =>
    setModals({ cancelModal: false, rescheduleModal: false });

  if (!data) return null;

  const arrFiles: string[] = [];

  const { appointmentTypeID } = data;

  let cep = "";

  let obs = "";

  data?.forms[0].values.forEach((form) => {
    if (form.name.toLowerCase() === "pedido médico" && form.value) {
      arrFiles.push(form.value);
    }

    if (form.name.toLowerCase() === "cep" && form.value) {
      cep = form.value;
    }

    if (form.name.toLowerCase().includes("observação") && form.value) {
      obs = form.value;
    }
  });

  const {
    email,
    firstName,
    lastName,
    id,
    phone,
    calendar,
    datetime,
    canceled,
    canClientCancel,
    canClientReschedule,
  } = data;

  const [date, time] = datetime?.split("T") || [];

  const [yyyy, mm, dd] = date?.split("-");
  const timeSchedule = time?.slice(0, 5);
  const dateSchedule = `${dd}/${mm}/${yyyy}`;

  return (
    <>
      <Modal
        isOpen={openModal}
        bodyOpenClassName="modal-content-open"
        className="modal-content modal-fixed-header modal-product"
        overlayClassName={{
          base: "modal",
          afterOpen: "after-open",
          beforeClose: "before-close",
        }}
        closeTimeoutMS={500}
        onRequestClose={closeModal}
      >
        <ModalStyle>
          <div className="heading">
            <h3>Dados do cliente</h3>
            <Button onClick={closeModal}>
              <X color="black" />
            </Button>
          </div>

          <div className="order-item">
            <p>Número do agendamento</p>
            <span>{id}</span>
          </div>

          <div className="order-item">
            <p>Nome do paciente</p>
            <span>
              {firstName} {lastName}
            </span>
          </div>

          <div className="order-item">
            <p>E-mail</p>
            <span>{email}</span>
          </div>

          <div className="order-item">
            <p>Telefone</p>
            <span>{formatPhoneNumberIntl(phone)}</span>
          </div>

          <div className="order-item">
            <p>Data do agendamento</p>
            <span>{dateSchedule}</span>
          </div>

          <div className="order-item">
            <p>Hórário do agendamento</p>
            <span>{timeSchedule}</span>
          </div>

          <div className="order-item">
            <p>Agenda</p>
            <span>{calendar}</span>
          </div>

          <div className="order-item">
            <p>Status</p>
            <span>{canceled ? "Cancelado" : "Ativo"}</span>
          </div>

          {obs !== "" && (
            <div className="order-item">
              <p>Observações</p>
              <span>{obs}</span>
            </div>
          )}

          {arrFiles.length >= 1 && (
            <div className="order-item">
              <p>Pedidos médicos</p>
              <Box display="flex" direction="column" gap="5" align="start">
                {arrFiles.map((file) => (
                  <a href={file} key={file} target="_blank" rel="noreferrer">
                    {file}
                  </a>
                ))}
              </Box>
            </div>
          )}

          <Box display="flex" justify="center" mt="30">
            {canClientReschedule && (
              <Button onClick={openRescheduleModal}>Alterar agendamento</Button>
            )}
            {canClientCancel && (
              <Button classButton="danger" onClick={openCancelModal}>
                Cancelar agendamento
              </Button>
            )}
          </Box>
        </ModalStyle>
      </Modal>

      {modals.cancelModal && (
        <CancelModal
          acuityId={id}
          isOpen={modals.cancelModal}
          refetch={refetch}
          requestClose={closeCancelModal}
        />
      )}

      {modals.rescheduleModal && (
        <RescheduleModal
          acuityId={id}
          isOpen={modals.rescheduleModal}
          refetch={refetch}
          requestClose={closeRescheduleModal}
          cep={cep || ""}
          appointmentTypeID={appointmentTypeID}
        />
      )}
    </>
  );
};
